import React from 'react';

const stepLabels = ["Terapeuta", "Horario", "Detalles", "Pago"];

const Progress = ({ selected }) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-start mb-2">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="flex flex-col items-center flex-1 relative">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all z-10 ${
                i <= selected
                  ? "bg-gray-900 text-white"
                  : "bg-gray-300 text-gray-500"
              }`}
            >
              {i + 1}
            </div>
            <span
              className={`text-xs mt-2 font-semibold text-center ${
                i <= selected ? "text-gray-900" : "text-gray-500"
              }`}
            >
              {stepLabels[i]}
            </span>
            {i < 3 && (
              <div
                className={`absolute top-5 left-1/2 w-full h-0.5 -z-10 ${
                  i < selected ? "bg-gray-900" : "bg-gray-300"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Progress;
